<div class="position-relative d-flex text-center align-items-center ml-2" [ngClass]="{'opacity-6 no-select pointer-events-none' : loader}">
  @if (loader) {
    <div class="spinner-border spinner-border-sm my-1 top-0 left-0 position-absolute"></div>
  }
  <ng-content></ng-content>
</div>
